import { get, post, postFileDownload } from "../../../services/request";

export const fetchUser = data => post('UserManagement/GetUsersList', {
	pageNumber: data.pageNumber || data.PageNumber || 1,
	pageSize: data.pageSize || data.PageSize || 10,
	searchText: data.searchText || data.SearchText || "",
	sortColumn: data.sortColumn || data.SortColumn || "UserID",
	sortColumnDir: data.sortColumnDir || data.SortColumnDir || "DESC"
});
export const fetchUserById = data => get(`UserManagement/GetUserById?userId=${data}`);
export const saveUser = data => post('UserManagement/SaveUser', data);
export const exportUserData = data => post('UserManagement/GetUserExportData', data);
export const importUserData = data => post('UserManagement/ImportUserData', data);
export const deleteUser = data => get(`UserManagement/DeleteUser?userId=${data}`);
export const fetchFileImportDetails = data => post(`UserManagement/GetFileImportDetails`, data);
export const downloadImportedFile = data => post(`UserManagement/DownloadImportedFile`, data);
export const fetchUserActivity = data => post('Common/UserInvestmentActivityExport', data);
export const exportUserActivity = data => postFileDownload('Common/UserInvestmentActivityExport', data);
export const resetMfa = data => post('Login/ResetMFA', data);
export const resendWelcomeEmail = data => post('UserManagement/ResendWelcomeEmail', data);
export const sendPendingWelcomeEmails = data => post('UserManagement/ProcessPendingPasswordEmails', data);
export const fetchUserAuthorizedMapping = data => post('UserManagement/GetUserAuthorizedMapping', data);
export const toggleUserAuthorizedMapping = data => post('UserManagement/ToggleUserAuthorizedMapping', data);